export default "__VITE_ASSET__DHEvVKKD__"